import { createRouter, createWebHistory } from 'vue-router';
import { NotFound } from '@os-web/components';

const HomePage = () => import('../pages/home/index.vue');
const UnsubscribePage = () => import('../pages/unsubscribe/index.vue');

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      meta: {
        tab: 'home',
      },
    },
    {
      path: '/tools',
      name: 'tools',
      component: HomePage,
      meta: {
        tab: 'tools',
      },
    },
    {
      path: '/tools/five-elements',
      name: 'tools-five-elements',
      component: HomePage,
      meta: {
        tab: 'toolsDetail',
        tool: 'fiveElements',
        showBreadcrumb: true,
        breadcrumb: [{ label: 'Our Tools', tab: 'tools' }, { label: 'Five Elements Test' }],
      },
    },
    {
      path: '/course',
      name: 'course',
      component: HomePage,
      meta: {
        tab: 'course',
      },
    },
    {
      path: '/course/:courseId',
      name: 'course-detail',
      component: HomePage,
      meta: {
        tab: 'courseDetail',
        showBreadcrumb: true,
        breadcrumb: [{ label: 'Course', tab: 'course' }, { label: 'Course Detail' }],
      },
    },
    {
      path: '/shop',
      name: 'shop',
      component: HomePage,
      meta: {
        tab: 'shop',
        cartCount: 1,
        headerAction: 'account',
      },
    },
    {
      path: '/shop/product/:productId',
      name: 'shop-product',
      component: HomePage,
      meta: {
        tab: 'shopProduct',
        cartCount: 1,
      },
    },
    {
      path: '/shop/checkout',
      alias: '/shop/cart',
      name: 'shopping-cart',
      component: HomePage,
      meta: {
        tab: 'shopCheckout',
      },
    },
    {
      path: '/shop/delivery',
      name: 'delivery-status',
      component: HomePage,
      meta: {
        tab: 'deliveryStatus',
      },
    },
    {
      path: '/shop/payment/success/:orderId?',
      name: 'shop-payment-success',
      component: HomePage,
      meta: {
        tab: 'shopPaymentSuccess',
        cartCount: 1,
        headerAction: 'account',
      },
    },
    {
      path: '/shop/support',
      name: 'shop-support',
      component: HomePage,
      meta: {
        tab: 'support',
        showBreadcrumb: true,
        breadcrumb: [
          { label: 'My Orders', tab: 'orders' },
          { label: 'Shop', tab: 'shop' },
          { label: 'Support service' },
        ],
      },
    },
    {
      path: '/learn',
      name: 'learn',
      component: HomePage,
      meta: {
        tab: 'learn',
      },
    },
    {
      path: '/advisors',
      name: 'advisors',
      component: HomePage,
      meta: {
        tab: 'advisors',
      },
    },
    {
      path: '/advisors/:teacherId',
      name: 'advisor-detail',
      component: HomePage,
      meta: {
        tab: 'advisorDetail',
        showBreadcrumb: false,
        breadcrumb: [{ label: 'Advisors', tab: 'advisors' }, { label: 'Advisor Detail' }],
      },
    },
    {
      path: '/service',
      name: 'service',
      component: HomePage,
      meta: {
        tab: 'service',
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: HomePage,
      meta: {
        tab: 'faq',
      },
    },
    {
      path: '/account/profile',
      name: 'account-profile',
      component: HomePage,
      meta: {
        tab: 'account',
      },
    },
    {
      path: '/account/orders',
      name: 'account-orders',
      component: HomePage,
      meta: {
        tab: 'orders',
      },
    },
    {
      path: '/support',
      name: 'support',
      component: HomePage,
      meta: {
        tab: 'support',
        showBreadcrumb: true,
        breadcrumb: [{ label: 'My Orders', tab: 'orders' }, { label: 'Support service' }],
      },
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      component: UnsubscribePage,
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: NotFound,
    },
  ],
});

export default router;
